export var clientRequestIdHeader = 'client-request-id';
export var dbNamePrefix = 'edgeworth-';
export var dbStoreName = 'edgeworth-files';
export var dbVersion = 32;
export var excludedApps = 'WebLink';
export var excludeAppsParam = 'excludeApps=';
export var localeParam = 'rs=';
export var groupParam = 'groups=';
export var preloadUserIdStorageKey = 'EwPreloadUserStorageId';
export var safeLinksRegex = /^https?:\/\/\S+\.safelinks\.protection\.outlook\.com/;
export var storageKeyPrefix = '_Edgeworth';
export var lastSyncTimestampKeySuffix = 'LastSyncTimestamp';
export var lastUiSyncTimestampKeySuffix = 'LastUiSyncTimestamp';
export var msaUserHintKey = 'MsaUserHint';
export var paintEwFirstMarker = 'Paint_EdgeworthFirst';
export var dateProperties = new Set([
    't',
    'latest_datetime',
    'useractions_datetime',
    'last_access_datetime',
    'last_modified_datetime',
    'last_shared_datetime',
    'save_for_later_datetime',
    'created_datetime',
    'timestamp',
    'last_action_datetime',
]);
export var headerDiagnostics = 'x-ms-diagnostics';
/* Recent */
export var recentQueryKey = [
    'EdgeworthData',
    "Recent" /* QuerySubtype.Recent */,
];
/* Favorites */
export var favoritesQueryKey = [
    'EdgeworthData',
    "Favorites" /* QuerySubtype.Favorites */,
];
/* Settings */
export var SettingsCacheKeyPrefix = '_EdgeworthSettings';
/* Metafolders */
export var documentsCardId = 'ew-documents';
// Hard coded tenant ID for MSA users used within Exchange/Substrate. AAD has a different one
export var SubstrateConsumerTenantId = '84df9e7f-e9f6-40af-b435-aaaaaaaaaaaa';
/** Hard-coded GUID that represents the {@link container_type_id} of a Raas (Repository as a Service) Loop page */
export var RaasLoopPageContainerTypeId = '3b4dc1c7-6dec-4bb2-8245-7dbf7cc4c72d';
//# sourceMappingURL=Constants.js.map